<app-modal [title]="modalTitle" [icon]="{ svgName: modalIcon }">
  <app-index-form [origin]="origin" [editIndex]="editIndex"> </app-index-form>
</app-modal>
